//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      recordObj: {},
      recordList: [],
      recordListType: 0,
      allRecord: {},
      dataNullIcon: require("@/assets/image/icon/icon_null.png"), //没数据icon
      selectTab: 0,
      userData: {},
      grade: -1,
      loading: true,
      pageNo: 1,
      total: '',
      userId: '',
      rateConfig: JSON.parse(localStorage.getItem('rateConfig')),
      noMore: false,
      finished: false
    };
  },
  methods: {
    onClickLeft(){
      this.$router.back()
    },
    getData() {
      let that = this
      this.LOGIN2.getSession("no login")
        .then(returnSession => {
          console.log("session", returnSession);
          this.userId = returnSession.userId
          let postD = {
            pageNo: 1,
            pageSize: 10 ,//暫不實現分頁
            userIds: returnSession.userId
          };
          //console.log("postD", postD);
          //this.$toast.loading();
          // 有session
          this.GLOBAL_.ccRequest.doSessionAxios(this.CONFIG.ORDER.BUYLIST,postD, "POST", "no login", false, "set storage") //正式
            .then(res => {
              this.recordObj = res;
              this.recordList = res.rows;
              this.total = res.total;
              console.log(res);
              //this.$toast.close();
              if(res.total < 10){
                that.finished = true
              }

              if (res.rows.length > 0 ) {
                this.recordListType = 1;
              } else {
                this.recordListType = 2;
              }
            })
            .catch(err => {
              this.$toast.close();
              this.recordListType = 2;
              // console.log(err, "错误");
              if (err.response.data.code != 401) {
                //this.$toast.text(err.response.data.message);
              }
            });
        })
        .catch(err => {
          // console.log(err);
          //沒有session
        });
    },

    goPage(url) {
      let obj = {
        router: this.$router,
        path: this.UTILS.splitUrl(url),
        query: {
          id: 1
        }
      };
      this.GLOBAL_.ccApp.openTo(obj);
    },
    getScrollDate(name) {
      let that = this;

      let nScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      let nClientHeight = document.documentElement.clientHeight;
      if (
        nScroll + nClientHeight >= document.body.scrollHeight - 50 &&
        that.loading
      ) {
        that.pageNo = that.pageNo + 1;
        that.loading = false;
        let postD = {
          pageNo: that.pageNo,
          pageSize: 24,
          userIds: this.userId
        };
        //this.$toast.loading();
        that.GLOBAL_.ccRequest.doSessionAxios(that.CONFIG.ORDER.BUYLIST, postD, "POST", "no login") //正式
          .then(res => {
            //this.$toast.close();
            that.recordList = that.recordList.concat(res.rows);
            if (res.rows.length == 0  || this.total == res.total) {
              that.loading = false;
              //this.$toast.text("到底啦！");
              that.noMore = true;
            } else {
              that.loading = true;
            }
          })
          .catch(err => {
            this.$toast.close();
            // console.log(err, "错误");
            console.log(err);
            if (err.response.data.code != 401) {
              this.$toast.text(err.response.data.message);
            }
          });
      }
    }
  },
  mounted() {

    this.getData();
    let that = this;
    window.addEventListener("scroll", this.getScrollDate);
  },
  destroyed() {
    //销毁滚动事件
    window.removeEventListener("scroll", this.getScrollDate);
  }
};



// WEBPACK FOOTER //
// ./src/pages/me/expensesRecord.vue